module.exports = __webpack_public_path__ + "images/icons/icon-error-6ecd85fb.svg";